"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// This file is automatically updated at build-time
var _default = exports.default = '8.16.6';